const it = {
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Accedi',
  'nav.signOut': 'Esci',
  'nav.signingIn': 'Accesso in corso…',
  'nav.loading': 'Caricamento…',
  'nav.backToDashboard': 'Torna alla dashboard',
  'nav.back': 'Indietro',
  'nav.language': 'Lingua',

  'credits.label': 'Crediti: {count}',
  'credits.loading': 'Crediti: —',
  'credits.buyMore': 'Acquista crediti',
  'credits.tooltipBuy': 'Clicca per acquistare altri crediti',
  'credits.tooltipLoading': 'Caricamento del saldo crediti',

  'auth.title': 'Accedi per continuare',
  'auth.subtitle': 'Accedi con Google per ricevere i crediti gratuiti e tenere traccia del tuo utilizzo',
  'auth.google': 'Continua con Google',
  'auth.signOutFailed': 'Non è stato possibile uscire. Riprova.',
  'auth.signInFailed': 'Non è stato possibile accedere. Riprova.',

  'landing.headline': 'Crea la foto che non hai scattato.',
  'landing.sub': 'Accedi per iniziare. I primi tre crediti li offriamo noi.',
  'landing.note': 'Un credito per immagine, addebitato solo quando l’immagine arriva.',

  'dash.eyebrow': 'Strumenti',
  'dash.headline': 'Crea la foto che non hai scattato.',
  'dash.sub': 'Scegli uno strumento. Ognuno costa un credito, e solo se funziona.',

  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Mappa → veduta',
  'tool.arrow.desc': 'Punta una freccia sulla mappa e guarda che veduta si ha da lì.',
  'tool.person.name': 'Rimuovi persone',
  'tool.person.transform': 'Folla → vuoto',
  'tool.person.desc': 'Togli gli sconosciuti dalla foto e tieni il posto in cui sei stato.',
  'tool.clothing.name': 'Prova virtuale',
  'tool.clothing.transform': 'Capo → te',
  'tool.clothing.desc': 'Indossa un capo prima di decidere se comprarlo.',

  'upload.title': 'Carica la tua immagine',
  'upload.hint': 'Clicca per scegliere un’immagine o trascinala qui',
  'upload.formats': 'Formati: JPG, PNG, GIF • Dimensione massima: 10 MB',
  'upload.person': 'Carica la foto della persona',
  'upload.clothing': 'Carica la foto del capo',
  'upload.selectImage': 'Clicca per scegliere un’immagine',
  'upload.formatsShort': 'JPG, PNG — max 10 MB',
  'upload.tooLarge': 'L’immagine supera i 10 MB. Scegline una più piccola.',
  'upload.notImage': 'Il file non è un’immagine. Scegli un JPG o un PNG.',

  'action.generate': 'Genera',
  'action.generating': 'Generazione…',
  'action.download': 'Scarica',
  'action.share': 'Condividi',
  'action.delete': 'Elimina',
  'action.cancel': 'Annulla',
  'action.tryAgain': 'Riprova',
  'action.uploadCustom': 'Carica il tuo',
  'action.browseLibrary': 'Sfoglia la libreria',

  'history.show': 'Mostra immagini recenti ({count})',
  'history.hide': 'Nascondi immagini recenti',
  'history.empty': 'Ancora niente. Le immagini che generi compariranno qui.',

  'gen.working': 'Stiamo creando la tua immagine…',
  'gen.takesTime': 'Di solito ci vuole meno di un minuto.',
  'gen.noCredits': 'Hai finito i crediti. Acquistane altri per continuare.',
  'gen.failed': 'Non ha funzionato. Il credito non è stato addebitato.',
  'gen.blocked': 'Il filtro di sicurezza ha rifiutato la foto. Provane un’altra: il credito non è stato addebitato.',

  'pay.title': 'Acquista crediti',
  'pay.subtitle': 'I crediti non scadono.',
  'pay.creditsLabel': '{count} crediti',
  'pay.saved': 'risparmi {amount}',
  'pay.pay': 'Paga {amount}',
  'pay.processing': 'Elaborazione…',
  'pay.success': 'Pagamento completato. I crediti sono stati aggiunti.',
  'pay.failed': 'Pagamento non riuscito. Non ti abbiamo addebitato nulla.',
  'pay.completeTitle': 'Pagamento completato',
  'pay.completeBody': 'I crediti sono stati aggiunti al tuo account.',

  'error.title': 'Qualcosa è andato storto',
  'error.body': 'La pagina ha incontrato un errore imprevisto. Di solito basta ricaricare.',
  'error.reload': 'Ricarica la pagina',
  'notFound.title': 'Pagina non trovata',
  'notFound.body': 'Questo indirizzo non corrisponde a nulla nello studio.',
  'notFound.home': 'Vai alla dashboard',

  'footer.privacy': 'Informativa sulla privacy',
};

export default it;
